import { Box, Text } from "@chakra-ui/react";
import React from "react";

interface StatusBadgeConfig {
  bgColor: string;
  textColor: string;
  label: string;
}

const getMembershipRequestStatusConfig = (
  status?: string | null
): StatusBadgeConfig => {
  switch (status) {
    case "Incomplete by User":
      return {
        bgColor: "membershipRequestStatus.incomplete.bg",
        textColor: "membershipRequestStatus.incomplete.text",
        label: "Incomplete by User",
      };
    case "Awaiting Staff Review":
      return {
        bgColor: "membershipRequestStatus.awaitingReview.bg",
        textColor: "membershipRequestStatus.awaitingReview.text",
        label: "Awaiting Staff Review",
      };
    case "Accepted Applications":
      return {
        bgColor: "membershipRequestStatus.accepted.bg",
        textColor: "membershipRequestStatus.accepted.text",
        label: "Accepted",
      };
    case "Rejected Applications":
      return {
        bgColor: "membershipRequestStatus.rejected.bg",
        textColor: "membershipRequestStatus.rejected.text",
        label: "Rejected",
      };
    case "In Error":
      return {
        bgColor: "membershipRequestStatus.error.bg",
        textColor: "membershipRequestStatus.error.text",
        label: "In Error",
      };
    case "Created Instantly":
      return {
        bgColor: "membershipRequestStatus.createdInstantly.bg",
        textColor: "membershipRequestStatus.createdInstantly.text",
        label: "Created Instantly",
      };
    default:
      return {
        bgColor: "membershipRequestStatus.incomplete.bg",
        textColor: "membershipRequestStatus.incomplete.text",
        label: status ?? "",
      };
  }
};

interface MembershipRequestStatusBadgeProps {
  status?: string | null;
}

export const MembershipRequestStatusBadge = ({
  status,
}: MembershipRequestStatusBadgeProps) => {
  if (!status) {
    return null;
  }

  const config = getMembershipRequestStatusConfig(status);

  return (
    <Box
      bg={config.bgColor}
      borderRadius="full"
      px={2.5}
      py={0.5}
      display="inline-flex"
      alignItems="center"
    >
      <Text
        fontSize="xs"
        fontWeight="semibold"
        color={config.textColor}
        lineHeight="short"
      >
        {config.label}
      </Text>
    </Box>
  );
};
